/*
 * @Author: Administrator
 * @Date:   2018-07-09 11:48:39
 * @Last Modified by: maoyanping
 * @Last Modified time: 2020-05-25 10:13:455
 */
import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";

import { getInfo } from "../api/url.js";

import { menu } from "./modules/menu";

import { parking } from "./modules/parking";

import { fullscreen } from "./modules/fullscreen.js";

import { arrearsInformation } from "./modules/arrearsInformation.js";
import { tabNavigation } from "../page/commons/BoskTabNavigation/store/index.js";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const state = {
  adminInfo: {
    avatar: "default.jpg",
  },
  //
  page: {
    curIndex: 1, //当前页数
    rowsCount: null, //总页数
  },
  storage: {
    scenId: null,
  },
  // menu:{
  // 	isCollapse:false
  // },
  elements: {},
  nodeData: null,
  nod: null,
};
const getters = {
  elements: (state) => state.elements,
};

const mutations = {
  saveAdminInfo(state, adminInfo) {
    state.adminInfo = adminInfo;
  },
  getPage(state, pageObj) {
    state.page.curIndex = pageObj.curIndex;
    state.page.rowsCount = pageObj.rowsCount;
  },
  setNodeData(state, node) {
    state.nodeData = node;
  },
  setNod(state, nod) {
    state.nod = nod;
  },
  storageScenId(state, scenId) {
    state.storage.scenId = scenId;
  },
  handleMenuStore(state, openState) {
    state.menu.isCollapse = openState;
  },
  setElements: (state, elements) => {
    state.elements = elements;
  },
};

const actions = {
  getAdminData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(getInfo(), {}).then((data) => {
        var data = data.data;
        // console.log(data)
        const elements = {};
        for (let i = 0; i < data.elements.length; i++) {
          // console.log(data.elements[i].uri);
          elements[data.elements[i].code] = true;
        }
        commit("setElements", elements);
      });
    });
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    menu,
    parking,
    fullscreen,
    arrearsInformation,
    tabNavigation

  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      storage: sessionStorage,
      paths: ["menu", "parking", "fullscreen", "arrearsInformation",],
    }),
  ],
});
